import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from 'redux/store'

import { LeftPaneVisibility } from '../LeftPanel'

const initialState = {
  visibility: { system: 'auto', user: 'auto' },
}

const leftPanelSlice = createSlice({
  name: 'leftPanel',
  initialState,
  reducers: {
    showLeftPanel: (
      state,
      action: PayloadAction<
        { visibility?: LeftPaneVisibility; isUserAction?: boolean } | undefined
      >
    ) => {
      state.visibility.system = action.payload?.visibility || 'visible'
      state.visibility.user = action.payload?.isUserAction
        ? 'visible'
        : state.visibility.user
    },
    hideLeftPanel: (
      state,
      action: PayloadAction<
        { visibility?: LeftPaneVisibility; isUserAction?: boolean } | undefined
      >
    ) => {
      state.visibility.system = action.payload?.visibility || 'hidden'
      state.visibility.user = action.payload?.isUserAction
        ? 'hidden'
        : state.visibility.user
    },
    resetLeftPanel: (state) => {
      state.visibility = initialState.visibility
    },
  },
})

export const { showLeftPanel, hideLeftPanel, resetLeftPanel } =
  leftPanelSlice.actions

export const selectLeftPanelVisibility = createSelector(
  [(state: RootState) => state.leftPanel.visibility],
  (visibility) => {
    const { user: userVisibility, system: systemVisibility } = visibility
    if (
      userVisibility === 'hidden' &&
      (systemVisibility === 'auto' || systemVisibility === 'visible')
    ) {
      return 'hidden'
    }
    return systemVisibility
  }
)

export default leftPanelSlice.reducer
